
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.242 1.586c-.37 0-.67.06-.898.18-.23.12-.482.359-.758.718l-.484-.421c.442-.62.833-1.03 1.171-1.227.339-.203.8-.305 1.383-.305h6.586v1.055h-1.89v4.687c0 .683.195 1.024.585 1.024.224 0 .493-.13.805-.39l.305.468c-.583.5-1.151.75-1.703.75-.448 0-.784-.151-1.008-.453-.219-.302-.328-.81-.328-1.524V1.586H3.609V8H2.04v-.383c.323-1.224.484-2.875.484-4.953V1.586h-.28z","fill":"currentColor"}})])
          )
        }
      }
    